export const toggleswitch = {
  root: { borderRadius: '30px', width: '3rem' },
  handle: {
    // borderRadius: '6px',
    size: '1.2rem',
  },
  colorScheme: {
    light: {
      background: 'grey',
      borderColor: '{primary.400}',
      color: '{paginator.color}',
      navButton: {
        color: 'black',
        selectedColor: 'black',
      },
      hover: {
        background: 'grey',
      },
    },
    dark: {
      padding: '6px 12px',
      background: '#3C434F',
      borderColor: '#aeb5b7',
      currentPageReportColor: '#aeb5b7',
      color: '#ffffff',
      handle: {
        size: '17px',
      },
      hover: {
        background: '#3C434F',
      },
    },
  },
};
